import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useAppearanceStore } from "@/store/appearanceStore";
import { LIGHT_STYLES, currentLightStyle, setLightStyle, type LightStyle } from "@/lib/lightStyle";
import { testIds } from "@/testIds";
import styles from "./AppearanceChoice.module.scss";

const M = testIds.mobile;
const CHOICES = ["system", "light", "dark"] as const;

/**
 * Appearance on a phone (Olivia, 10 Oct): System · Light · Dark, shared with the
 * desktop's switch. In a document's ⋯ and the account sheet, on one line. On the
 * phone's Settings page (`full`), also the light style being tried (the user, 11 Oct:
 * "mobile also for switching"), a native picker: no keyboard. The user, 17 Oct: the
 * account sheet was invasive, so the trial lives in Settings only.
 */
export function AppearanceChoice({ full = false }: { full?: boolean }) {
  const { t } = useTranslation("mobile");
  const appearance = useAppearanceStore((s) => s.appearance);
  const setAppearance = useAppearanceStore((s) => s.setAppearance);
  const [lightStyle, setStyle] = useState<LightStyle>(currentLightStyle);
  return (
    <div className={full ? styles.row : styles.inline} data-testid={M.appearance}>
      <span>{t("appearance.label")}</span>
      <div className={styles.segmented} role="radiogroup" aria-label={t("appearance.label")}>
        {CHOICES.map((a) => (
          <button
            key={a}
            type="button"
            role="radio"
            aria-checked={(appearance ?? "system") === a}
            data-testid={`${M.appearance}-${a}`}
            onClick={() => setAppearance(a)}
          >
            {t(`appearance.${a}`)}
          </button>
        ))}
      </div>
      {full && <label className={styles.lightStyle}>
        <span>{t("appearance.lightStyle")}</span>
        <select
          value={lightStyle}
          data-testid={M.lightStyle}
          onChange={(e) => {
            const v = e.target.value as LightStyle;
            setLightStyle(v);
            setStyle(v);
          }}
        >
          {LIGHT_STYLES.map((l) => (
            <option key={l.name} value={l.name}>
              {l.label}
            </option>
          ))}
        </select>
      </label>}
    </div>
  );
}
